//#region import libraries
import React, { useEffect, useRef, useState } from 'react';

// bootstrap
import { Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

// tremor
import { Flex, Subtitle } from '@tremor/react'
//QRcode
import { QRCode } from 'react-qrcode-logo';
//icons
import { FaRegEye } from 'react-icons/fa6';

// custom components
import { Card, Accordion, CustomSpinner, CustomQrCode } from '_atoms';
import { CustomTooltip, QuestionComponent } from '_organisms';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectQuestions, getQuestions, updateSurveyAvailability, selectPostQuestionnaireStatus, resetPostSurveyFlags, selectUpdateSurveyStatus } from '_redux/slices/analytics/review-control-panel';
import { selectIata } from '_redux/slices/main-screen/user';

// STYLING
import { Spacing, Colors } from '_styles';
import SurveyQuestionnaireForm from '../../../../components/organisms/feedback/survey-questionnaire-form';
import { ActionsModal } from '_components/molecules';

//#endregion

const ReviewControlPanel = () => {


    // states
    const [showOnboard, setShowOnboard] = useState(true);
    const [showCreateSurvey, setShowCreateSurvey] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fileName, setFileName] = useState("");
    const [surveyTitle, setSurveyTitle] = useState("");
    // redux
    const dispatch = useDispatch();

    const iata = useSelector(selectIata);
    const questions = useSelector(selectQuestions);
    const postQuestionnaireStatus = useSelector(selectPostQuestionnaireStatus);
    const updateSurveyStatus = useSelector(selectUpdateSurveyStatus);

    const [link, setLink] = useState("")
    useEffect(() => {
        // get questions       
        const data = { iata, passenger: false }
        dispatch(getQuestions(data))
    }, []);

    useEffect(() => {
        if (questions && questions[0] && questions[0].questions) {
            setShowOnboard(false);
        }
    }, [questions]);

    useEffect(() => {
        if (postQuestionnaireStatus === "succeeded" || updateSurveyStatus === "succeeded") {
            dispatch(resetPostSurveyFlags());
            setShowCreateSurvey(false);
            const data = { iata, passenger: false }
            dispatch(getQuestions(data))
        };
    }, [postQuestionnaireStatus, updateSurveyStatus])


    const createSurvey = () => {
        setShowCreateSurvey(true);
    }

    const activateSurvey = (surveyId, active) => {
        const data = { surveyId, active, iata }
        dispatch(updateSurveyAvailability(data))
    }

    const handleCancel = () => {
        setShowCreateSurvey(false);
    };

    const handleGenerateQRCode = (survey) => {
        const url = `https://prmassist.com/caa-survey/${survey._id}/${iata}`;
        const fileName = `${survey._id}-${iata}`
        setLink(url);
        setSurveyTitle(survey.groupTitle)
        setFileName(fileName)
        setShowModal(true);

    }

    const handleClose = () => {
        setShowModal(false);
        setFileName("")
        setLink("")
    }

    const handlePreview = (survey) => {
        const lang = survey.languages?.[0]?.value || "en";
        window.open(`/survey-preview/${iata}/${survey._id}?lang=${lang}`, "_blank");
    }

    if (showCreateSurvey) {
        return (
            <SurveyQuestionnaireForm handleCancel={handleCancel} />
        )
    }
    if (showOnboard) {
        return (
            <div className='mt-3'>
                <Row>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>

                        <div style={{ alignItems: 'center', textAlign: 'center' }}>
                            <p style={{ fontSize: '24px', fontWeight: '500' }}>PRM Passenger Survey</p>
                            <p style={{ fontSize: '22px', fontWeight: '500', color: Colors.LIGHT_GREY, marginTop: -Spacing.SCALE_12, opacity: 0.8 }}>Create surveys for your passengers to complete</p>
                        </div>

                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button
                            variant={"outline-primary"}
                            style={{ width: 200 }}
                            onClick={createSurvey}>Create Survey
                        </Button>
                    </div>
                </Row>
            </div>
        );
    }
    else {
        return (
            <div>
                <Row className='mt-3'>

                    <Flex>
                        <div>
                            <Subtitle>Create a survey for passengers to complete reviewing your airport</Subtitle>
                        </div>
                        <div>

                            <Button
                                variant={"outline-primary"}
                                style={{ width: 200 }}
                                onClick={createSurvey}>Create Survey</Button>
                        </div>
                    </Flex>



                    {/* survey list */}
                    <div className='mt-3'>
                        {
                            questions != undefined && questions[0] != undefined && questions[0].questions != undefined && questions.map((question, index) => {

                                index = index + 1;
                                return (

                                    <Accordion borderColor={!question.active && "red"} header={`${question.groupTitle}   (${question.surveyAudience})`} active={false} onStateChange={() => { console.log('changed state') }}>
                                        <Card >
                                            <div style={{ marginTop: -Spacing.SCALE_18, marginBottom: Spacing.SCALE_12 }}>
                                                <Flex>

                                                    {question.active && question.surveyAudience === "email-survey" ?
                                                        <Button
                                                            variant={"outline-primary"}
                                                            style={{ width: 200 }}
                                                            onClick={() => handleGenerateQRCode(question)}
                                                        >
                                                            Generate QR Code
                                                        </Button>
                                                        : <div style={{ width: 200 }}></div>
                                                    }

                                                    <CustomTooltip text={"Preview the survey as passengers will see it (opens in a new tab)."} placement="top">
                                                        <Button
                                                            variant={"outline-secondary"}
                                                            style={{ width: 200 }}
                                                            onClick={() => handlePreview(question)}
                                                        >
                                                            <FaRegEye style={{ marginRight: 6 }} /> Preview
                                                        </Button>
                                                    </CustomTooltip>

                                                    <CustomTooltip text={question.active ? "This survey will not be sent after deactivation." : "This survey will be sent after activation."} placement="top">

                                                        <Button
                                                            variant={question.active ? "outline-danger" : "outline-primary"}
                                                            style={{ width: 200 }}
                                                            onClick={() => activateSurvey(question._id, !question.active)}>
                                                            {updateSurveyStatus === "loading" ?
                                                                <CustomSpinner />
                                                                :
                                                                question.active ? "Deactivate" : "Activate"

                                                            }
                                                        </Button>

                                                    </CustomTooltip>
                                                </Flex>
                                            </div>
                                            {
                                                question.questions.map((q, i) => {
                                                    return (
                                                        <div style={{ padding: "5px" }}>
                                                            <QuestionComponent
                                                                question={q}
                                                                questionIndex={i + 1}
                                                                active={false}

                                                            />
                                                        </div>
                                                    )
                                                })}
                                        </Card>
                                    </Accordion>


                                )
                            })
                        }
                    </div>

                </Row>
                <ActionsModal show={showModal} handleClose={handleClose} title={`QR Code of survey: ${surveyTitle}`} subtitle={"You can either copy link of survey or download image for QR code"} minWidth="445px" maxWidth="445px" >
                    <CustomQrCode link={link} showInstructions={false} instructions={""} filename={fileName} />
                </ActionsModal>
            </div>
        );
    }
};

export default ReviewControlPanel;
